module.exports = __webpack_public_path__ + "static/media/offer-news-mobile.40394a93.png";